// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { folderOpen16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-folder-open': IconFolderOpen;
    }
}

/**
 * The icon component for the 'folderOpen' icon
 */
export class IconFolderOpen extends IconSvg {
    public constructor() {
        super(folderOpen16X16);
    }
}

registerIconSvg('icon-folder-open', IconFolderOpen);
export const iconFolderOpenTag = 'nimble-icon-folder-open';
